import { EraService } from './shared/eras.service';
import { MediaRegisterService } from './shared/media-register.service';

export const baseHref = (): string => {
  // const corpPrefix = pl.pathname.split('/')[1];
  // const storage = localStorage.getItem('corpPrefix');
  // if (storage && storage !== corpPrefix) {
  //   localStorage.removeItem('auth.accessToken');
  //   localStorage.removeItem('auth.refreshToken');
  //   localStorage.removeItem('auth.profile');
  //   localStorage.removeItem('setting');
  // }
  // return `/${corpPrefix}`;
  return "";
};

export const initEra = (eraService: EraService) => {
  return () => eraService.load();
}

export const mediaRegister = (mediaRegisterService: MediaRegisterService) => {
  return () => mediaRegisterService.init();
}